import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCookiesIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.93509 3.66726C8.41179 2.76789 10.1466 2.25 12 2.25C17.3848 2.25 21.75 6.61522 21.75 12C21.75 17.3848 17.3848 21.75 12 21.75C8.09949 21.75 4.73544 19.4596 3.17664 16.1536C2.90008 15.567 3.44793 14.9297 4.06936 15.115C4.36329 15.2027 4.67546 15.25 5.00001 15.25C6.79493 15.25 8.25001 13.7949 8.25001 12C8.25001 11.1493 7.92418 10.3765 7.38918 9.79671C7.10002 9.48334 7.12994 8.99226 7.45501 8.71632C7.94257 8.30244 8.25001 7.68751 8.25001 7C8.25001 6.11525 7.73944 5.34835 6.99347 4.98046C6.46304 4.71886 6.42996 3.9749 6.93509 3.66726ZM8.72597 4.42497C9.36035 5.09628 9.75001 6.00232 9.75001 7C9.75001 7.88345 9.44396 8.69588 8.93333 9.33636C9.44853 10.0959 9.75001 11.0133 9.75001 12C9.75001 14.5398 7.75667 16.614 5.24911 16.7436C6.7427 18.8652 9.21018 20.25 12 20.25C16.5564 20.25 20.25 16.5563 20.25 12C20.25 7.44365 16.5564 3.75 12 3.75C10.8358 3.75 9.72916 3.99073 8.72597 4.42497Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 13,
			cy: 7,
			r: 1,
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 13,
			cy: 13,
			r: 1,
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 11,
			cy: 18,
			r: 1,
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 16,
			cy: 16,
			r: 1,
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 17,
			cy: 10,
			r: 1,
			fill: "black"
		})
	]
});
export default SvgCookiesIcon;
